import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Talk2payHome from "@/components/screens/Platforms/Talk2payHome";
import {
  T2PAY_HOME_MESSAGES,
  T2PayHomeMessages,
} from "@/messages/platforms/talk2PayHome/t2pay-home.messages";
import translationService from "@/services/translation.service";
import { Language } from "@/types/language.types";

const Talk2PayCadastralPage: React.FC = () => {
  const { lang = "PT-BR" } = useParams<{ lang?: string }>();
  const [messages, setMessages] = useState<T2PayHomeMessages | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadMessages = async () => {
      try {
        const translations = await translationService.get<T2PayHomeMessages>(
          T2PAY_HOME_MESSAGES,
          (lang as Language) ?? null
        );
        setMessages(translations);
      } finally {
        setLoading(false);
      }
    };

    loadMessages();
  }, [lang]);

  if (loading) {
    return null; // Loading handled by Suspense in child components
  }

  if (!messages) {
    return <div>Erro ao carregar mensagens</div>;
  }

  return <Talk2payHome messages={messages} selectedNavigationItem="cadastral-situation" />;
};

export default Talk2PayCadastralPage;
